import type { Nutrient } from '../types.js'

export interface AlgorithmContext {
  amount: number
  nutrient: Nutrient
}

export interface AlgorithmResult {
  passing: boolean
}

export function scoreNutrient(context: AlgorithmContext): AlgorithmResult {
  const { amount, nutrient } = context

  switch (nutrient.algorithm) {
    case 'ignore':
      return { passing: true }

    case 'reachMinDontExceedMax': {
      const meetsMin = nutrient.min === undefined || amount >= nutrient.min
      const withinMax = nutrient.max === undefined || amount <= nutrient.max
      return { passing: meetsMin && withinMax }
    }

    case 'reachMin': {
      const aboveMin = nutrient.min === undefined || amount >= nutrient.min
      return { passing: aboveMin }
    }

    case 'dontExceedMax': {
      const belowMax = nutrient.max === undefined || amount <= nutrient.max
      return { passing: belowMax }
    }

    default:
      console.warn(`Unknown algorithm: ${nutrient.algorithm}`)
      return { passing: false }
  }
}
